import { DropdownRecord } from "common/components/Dropdown/Dropdown";
import { PatternDocType, PatternRecord } from "common/records/Pattern";
import { RootState } from "common/reducers";
import { getRecordsAsDropdownOptions, getRecordsByModel, ids } from "common/selectors/idsManagement.selectors";
import { List } from "immutable";
import { createSelector } from "reselect";
import { fromJSON } from "common/components/Dropdown/Dropdown";

const rootKey = "patterns";

/**
 * Loads byId key from patterns
 *
 * @param {RootState} state The RootState
 * @param {{}} options
 * @returns {Map<number, PatternRecord>} Map<number, PatternRecord>
 */
export const byId = (state: RootState) => state.getIn([rootKey, "byId"]);

/**
 * Loads pattern by patternId
 *
 * @param {RootState} state The RootState
 * @param {{ patternId: number }} options
 * @returns {PatternRecord} PatternRecord
 */
export const pattern = (state: RootState, props: { patternId: number }) => byId(state).get(props.patternId);

/**
 * Loads byId key from patterns
 *
 * @param {RootState} state The RootState
 * @param {{}} options
 * @returns {Map<number, PatternRecord>} Map<number, PatternRecord>
 */
export const lastSavedById = (state: RootState) => state.getIn([rootKey, "lastSavedById"]);

/**
 * Loads pattern by patternId
 *
 * @param {RootState} state The RootState
 * @param {{ patternId: number }} options
 * @returns {PatternRecord} PatternRecord
 */
export const lastSavedPattern = (state: RootState, props: { patternId: number }) =>
  lastSavedById(state).get(props.patternId);

/**
 * Loads pattern test data
 *
 * @param {RootState} state The RootState
 * @param {{}} options
 * @returns {PatternTestDataRecord} PatternTestDataRecord
 */
export const patternTestData = (state: RootState) => state.getIn([rootKey, "testData"]);

/**
 * Loads patternIds key from patterns
 *
 * @param {RootState} state The RootState
 * @param {{ docType: PatternDocType }} options
 * @returns {List<number>} List<number>
 */
export const patternIds = (state: RootState, props: { docType: PatternDocType }) =>
  ids(state, { modelName: `patterns-${props.docType}` }) as List<number>;

/**
 * Loads patterns as dropdown options with the passed docType
 *
 * @param {RootState} state The RootState
 * @param {{ docType: PatternDocType }} options
 * @returns {List<DropdownRecord>} List<DropdownRecord>
 */
export const docTypePatternRecords = (state: RootState, props: { docType: PatternDocType }) =>
  getRecordsAsDropdownOptions(state, {
    modelName: `patterns-${props.docType}`,
    path: ["patterns", "byId"],
  }) as List<DropdownRecord>;
